import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const WeatherRainyFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M21.06 12.3C21.06 14.4 19.38 16.02 17.18 16.02H8.86C6.76 16.02 5.28 14.7 5.28 12.84C5.28 12.6 5.3 12.38 5.36 12.16C4.14 11.54 3.32 10.28 3.32 8.84C3.32 6.8 5 5.1 7.06 5.1C8.18 5.1 9.18 5.6 9.88 6.38C10.66 5.92 11.6 5.64 12.62 5.64C14.54 5.64 16.38 6.76 17.34 8.74C19.68 8.8 21.06 10.38 21.06 12.3ZM5.06 8.84C5.06 9.64 5.56 10.34 6.24 10.66C6.6 10.34 7.04 10.12 7.52 10C7.64 9.06 8.02 8.22 8.56 7.54C8.2 7.12 7.64 6.84 7.06 6.84C5.98 6.84 5.06 7.76 5.06 8.84ZM16.6 18.28L14.16 20.68L13.02 19.54L15.44 17.12L16.6 18.28ZM12.86 18.28L10.42 20.68L9.28 19.54L11.7 17.12L12.86 18.28Z" />
    </SvgIcon>
  );
});
